import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, TextField, Typography } from '@mui/material';
import { ColorPicker } from 'material-ui-color';
import "../Projects/projects.css";
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import './branch.css'
import mainStore from '../../../MainStore';
import Loader from '../Loader';

export default class BranchTable extends Component {
    columns = [
        { title: 'Имя', field: 'name' },
        { title: 'Цвет', field: 'color' },
        { title: 'Активно', field: 'isActive' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            isEditDialogOpen: false,
            branches: [],
            isInLoading: false,
            rowData: {}
        };
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.accountId) return;
        var scope = this;
        this.setState({ isInLoading: true });
        mainStore.setMaskVisible();
        fetchWithAuth('api/Branch?accountId=' + this.props.accountId,
            null,
            '',
            (result) => {
                scope.setState({ branches: result, isInLoading: false });
                mainStore.setMaskUnvisible();
            },
            'GET',
        );
    }

    handleRowDataChange = name => evt => {
        var rowData = this.state.rowData;
        rowData[name] = evt.target.value;
        this.setState({ rowData: rowData });
    };

    handleRowCheckedChange = name => evt => {
        var rowData = this.state.rowData;
        rowData[name] = evt.target.checked;
        this.setState({ rowData: rowData });
    };

    handleColorChange(color) {
        if (color) {
            var rowData = this.state.rowData;
            rowData.color = color;
            this.setState({ rowData: rowData });
        }
    }

    handleSave() {
        let scope = this;
        mainStore.setMaskVisible();
        fetchWithAuth('api/Branch',
            JSON.stringify(this.state.rowData),
            'application/json',
            (result) => {
                let branches = scope.state.branches.slice(0);
                let index = branches.findIndex(b => b.id === result.id);

                if (index < 0) {
                    branches.push(result);
                }
                else {
                    branches.splice(index, 1, result);
                }
                scope.setState({ branches: branches, isEditDialogOpen: false });
                mainStore.setMaskUnvisible();
            },
            'POST',
        ); 
    }

    delete(rowData) {
        let scope = this;
        mainStore.setMaskVisible();
        fetchWithAuth('api/Branch/Delete',
            JSON.stringify(rowData),
            'application/json',
            (result) => {
                let branches = scope.state.branches.slice(0);
                let index = branches.findIndex(b => b.id === result.id);

                if (index >= 0) {                    
                    branches.splice(index, 1);
                }
                scope.setState({ branches: branches });
                mainStore.setMaskUnvisible();
            },
            'POST',
        );
    }

    handleClose() {
        this.setState({ "isEditDialogOpen": false });
    }

    render() {
        if (!this.props) {
            return <div></div>
        }
        return (
            <div>
                <Loader />
                <MaterialTable
                    title=""
                    columns={this.columns}

                    data={this.state.branches}
                    editable={{
                    }}
                    actions={[
                        {
                            icon: 'add',
                            tooltip: 'Добавить ветку',
                            isFreeAction: true,
                            onClick: (event) => this.setState({ "isEditDialogOpen": true, "rowData": { accountId: this.props.accountId} })
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.setState({ "isEditDialogOpen": true, "rowData": rowData })
                            }
                        },
                        {
                            icon: 'delete',
                            tooltip: 'Удалить',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.delete(rowData);
                            }
                        }
                    ]}
                    options={{
                        actionsColumnIndex: -1
                    }}
                />
                <Dialog
                    className="branch-edit-dialog"
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isEditDialogOpen}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Добавление новой ветки
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography component={'div'}>
                            <TextField required
                                id="standard-required"
                                label="Имя"
                                fullWidth
                                margin="normal"
                                value={this.state.rowData.name}
                                onChange={this.handleRowDataChange('name')} />
                        </Typography>
                        <Typography component={'div'}>
                            Цвет &nbsp;
                            <ColorPicker
                                name='color'
                                defaultValue={this.state.rowData.color}
                                // value={this.state.color} - for controlled component
                                onChange={this.handleColorChange}
                            />
                            <div className="project-color-example-square" style={{ background: this.state.rowData.color }}></div>
                        </Typography>
                        <Typography component={'div'}>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={this.state.rowData.isActive} onChange={this.handleRowCheckedChange('isActive')} value="true" />
                                }
                                label="Активно"
                            />
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>


        );
    }
}
